import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X, Download, ExternalLink } from "lucide-react";

export function DocPreviewModal({
  open,
  onOpenChange,
  url,
  title,
  subtitle,
  accent = "#00B5D8",
  downloadLabel = "Download",
  openLabel = "Open",
}) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogPrimitive.Content
          data-testid="doc-preview-modal"
          className="fixed left-[50%] top-[50%] z-[100] flex flex-col w-[96vw] max-w-5xl h-[92vh] translate-x-[-50%] translate-y-[-50%] rounded-2xl border bg-[#0a0a0a] shadow-2xl overflow-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95"
          style={{ borderColor: accent + "40" }}
        >
          <div className="flex items-center gap-3 px-5 md:px-6 py-4 border-b border-white/10">
            <div className="min-w-0 flex-1">
              <DialogPrimitive.Title className="font-display text-base md:text-lg text-white truncate">
                {title}
              </DialogPrimitive.Title>
              {subtitle && (
                <DialogPrimitive.Description className="text-xs text-white/50 truncate mt-0.5">
                  {subtitle}
                </DialogPrimitive.Description>
              )}
            </div>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              data-testid="doc-preview-open"
              className="hidden sm:inline-flex items-center gap-2 text-xs text-white/70 hover:text-white rounded-full border border-white/15 px-3 py-1.5 transition-colors"
            >
              <ExternalLink size={14} /> {openLabel}
            </a>
            <a
              href={url}
              download
              data-testid="doc-preview-download"
              className="inline-flex items-center gap-2 text-xs font-semibold text-black rounded-full px-3.5 py-1.5 hover:opacity-90 transition-opacity"
              style={{ background: accent }}
            >
              <Download size={14} /> {downloadLabel}
            </a>
            <DialogPrimitive.Close
              data-testid="doc-preview-close"
              className="rounded-full w-8 h-8 flex items-center justify-center text-white/70 hover:text-white hover:bg-white/10 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00B5D8]"
            >
              <X size={18} />
              <span className="sr-only">Close</span>
            </DialogPrimitive.Close>
          </div>
          {url && (
            <iframe
              src={`${url}#view=FitH`}
              title={title}
              className="flex-1 w-full bg-white"
              data-testid="doc-preview-frame"
            />
          )}
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
